'use client';

import React, { useEffect, useState } from 'react';
import { useUser } from '@clerk/nextjs';
import Checkout from '@/components/Checkout';
import { UserIcon } from 'lucide-react';
import Link from 'next/link';

// Sub-component to fetch and display individual donor names
const DonorRow = ({ donor }) => {
    const [username, setUsername] = useState('Loading...');
    const [profileLink, setProfileLink] = useState('');
    const [rank, setRank] = useState('')

    useEffect(() => {
        async function getUsername() {
            try {
                const res = await fetch(`/api/clerk-user?userId=${donor.user_id}`);
                const data = await res.json();
                console.log(data)
                setUsername(data.username || data.firstName || 'Anonymous');
                setProfileLink(data.imageUrl || '')
                setRank(data.rank || '')
            } catch (err) {
                setUsername('Contributor');
            }
        }
        getUsername();
    }, [donor.user_id]);

    return (
        <div className="flex justify-between items-center py-3 border-b last:border-0">
            <div className='flex flex-row'>{profileLink ? (
                <img
                    src={profileLink}
                    alt={username}
                    className={`w-9 h-9 rounded-full border border-amber-200 shadow-sm`}
                />

            ) : (
                <div className={`w-9 h-9 rounded-full bg-slate-200 flex items-center justify-center`}>
                    <UserIcon size={16} className={`text-slate-400`} />
                </div>
            )}
                <span className={`text-[16px] mt-1.5 tra ml-1 text-slate-600 font-sans font-bold`}>
                    {rank && (
                        <span className='bg-blue-300 text-[14px] ml-0 mr-1 px-1 text-stone-900 rounded-md'>
                            {rank}
                        </span>
                    )}
                      <Link href={`/profile/${username}`} className='mt-1 hover:underline'>
                  {username}
                  </Link>
                </span>
                <span className=' mt-[11.5px] ml-2 text-xs'>
                    {new Date(donor.created_at).toLocaleDateString()}
                </span>
                               
            </div>
            <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-bold">
                +${donor.amount_donated.toLocaleString()}
            </span>
        </div>
    );
};

export default DonorRow;